/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


 //odometer
/*! odometer 0.4.6 */
(function(){var a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G=[].slice;q='<span class="odometer-value"></span>',n='<span class="odometer-ribbon"><span class="odometer-ribbon-inner">'+q+"</span></span>",d='<span class="odometer-digit"><span class="odometer-digit-spacer">8</span><span class="odometer-digit-inner">'+n+"</span></span>",g='<span class="odometer-formatting-mark"></span>',c="(,ddd).dd",h=/^\(?([^)]*)\)?(?:(.)(d+))?$/,i=30,f=2e3,a=20,j=2,e=.5,k=1e3/i,b=1e3/a,o="transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd",y=document.createElement("div").style,p=null!=y.transition||null!=y.webkitTransition||null!=y.mozTransition||null!=y.oTransition,w=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame,l=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver,s=function(a){var b;return b=document.createElement("div"),b.innerHTML=a,b.children[0]},v=function(a,b){return a.className=a.className.replace(new RegExp("(^| )"+b.split(" ").join("|")+"( |$)","gi")," ")},r=function(a,b){return v(a,b),a.className+=" "+b},z=function(a,b){var c;return null!=document.createEvent?(c=document.createEvent("HTMLEvents"),c.initEvent(b,!0,!0),a.dispatchEvent(c)):void 0},u=function(){var a,b;return null!=(a=null!=(b=window.performance)?"function"==typeof b.now?b.now():void 0:void 0)?a:+new Date},x=function(a,b){return null==b&&(b=0),b?(a*=Math.pow(10,b),a+=.5,a=Math.floor(a),a/=Math.pow(10,b)):Math.round(a)},A=function(a){return 0>a?Math.ceil(a):Math.floor(a)},t=function(a){return a-x(a)},C=!1,(B=function(){var a,b,c,d,e;if(!C&&null!=window.jQuery){for(C=!0,d=["html","text"],e=[],b=0,c=d.length;c>b;b++)a=d[b],e.push(function(a){var b;return b=window.jQuery.fn[a],window.jQuery.fn[a]=function(a){var c;return null==a||null==(null!=(c=this[0])?c.odometer:void 0)?b.apply(this,arguments):this[0].odometer.update(a)}}(a));return e}})(),setTimeout(B,0),m=function(){function a(b){var c,d,e,g,h,i,l,m,n,o,p=this;if(this.options=b,this.el=this.options.el,null!=this.el.odometer)return this.el.odometer;this.el.odometer=this,m=a.options;for(d in m)g=m[d],null==this.options[d]&&(this.options[d]=g);null==(h=this.options).duration&&(h.duration=f),this.MAX_VALUES=this.options.duration/k/j|0,this.resetFormat(),this.value=this.cleanValue(null!=(n=this.options.value)?n:""),this.renderInside(),this.render();try{for(o=["innerHTML","innerText","textContent"],i=0,l=o.length;l>i;i++)e=o[i],null!=this.el[e]&&!function(a){return Object.defineProperty(p.el,a,{get:function(){var b;return"innerHTML"===a?p.inside.outerHTML:null!=(b=p.inside.innerText)?b:p.inside.textContent},set:function(a){return p.update(a)}})}(e)}catch(q){c=q,this.watchForMutations()}}return a.prototype.renderInside=function(){return this.inside=document.createElement("div"),this.inside.className="odometer-inside",this.el.innerHTML="",this.el.appendChild(this.inside)},a.prototype.watchForMutations=function(){var a,b=this;if(null!=l)try{return null==this.observer&&(this.observer=new l(function(){var a;return a=b.el.innerText,b.renderInside(),b.render(b.value),b.update(a)})),this.watchMutations=!0,this.startWatchingMutations()}catch(c){a=c}},a.prototype.startWatchingMutations=function(){return this.watchMutations?this.observer.observe(this.el,{childList:!0}):void 0},a.prototype.stopWatchingMutations=function(){var a;return null!=(a=this.observer)?a.disconnect():void 0},a.prototype.cleanValue=function(a){var b;return"string"==typeof a&&(a=a.replace(null!=(b=this.format.radix)?b:".","<radix>"),a=a.replace(/[.,]/g,""),a=a.replace("<radix>","."),a=parseFloat(a,10)||0),x(a,this.format.precision)},a.prototype.bindTransitionEnd=function(){var a,b,c,d,e,f,g=this;if(!this.transitionEndBound){for(this.transitionEndBound=!0,b=!1,e=o.split(" "),f=[],c=0,d=e.length;d>c;c++)a=e[c],f.push(this.el.addEventListener(a,function(){return b?!0:(b=!0,setTimeout(function(){return g.render(),b=!1,z(g.el,"odometerdone")},0),!0)},!1));return f}},a.prototype.resetFormat=function(){var a,b,d,e,f,g,i,j;if(a=null!=(i=this.options.format)?i:c,a||(a="d"),d=h.exec(a),!d)throw new Error("Odometer: Unparsable digit format");return j=d.slice(1,4),g=j[0],f=j[1],b=j[2],e=(null!=b?b.length:void 0)||0,this.format={repeating:g,radix:f,precision:e}},a.prototype.render=function(a){var b,c,d,e,f,g,h,i,j,k,l,m;for(null==a&&(a=this.value),this.stopWatchingMutations(),this.resetFormat(),this.inside.innerHTML="",g=this.options.theme,b=this.el.className.split(" "),f=[],i=0,k=b.length;k>i;i++)c=b[i],c.length&&((e=/^odometer-theme-(.+)$/.exec(c))?g=e[1]:/^odometer(-|$)/.test(c)||f.push(c));for(f.push("odometer"),p||f.push("odometer-no-transitions"),f.push(g?"odometer-theme-"+g:"odometer-auto-theme"),this.el.className=f.join(" "),this.ribbons={},this.digits=[],h=!this.format.precision||!t(a)||!1,m=a.toString().split("").reverse(),j=0,l=m.length;l>j;j++)d=m[j],"."===d&&(h=!0),this.addDigit(d,h);return this.startWatchingMutations()},a.prototype.update=function(a){var b,c=this;return a=this.cleanValue(a),(b=a-this.value)?(v(this.el,"odometer-animating-up odometer-animating-down odometer-animating"),b>0?r(this.el,"odometer-animating-up"):r(this.el,"odometer-animating-down"),this.stopWatchingMutations(),this.animate(a),this.startWatchingMutations(),setTimeout(function(){return c.el.offsetHeight,r(c.el,"odometer-animating")},0),this.value=a):void 0},a.prototype.renderDigit=function(){return s(d)},a.prototype.insertDigit=function(a,b){return null!=b?this.inside.insertBefore(a,b):this.inside.children.length?this.inside.insertBefore(a,this.inside.children[0]):this.inside.appendChild(a)},a.prototype.addSpacer=function(a,b,c){var d;return d=s(g),d.innerHTML=a,c&&r(d,c),this.insertDigit(d,b)},a.prototype.addDigit=function(a,b){var c,d,e,f;if(null==b&&(b=!0),"-"===a)return this.addSpacer(a,null,"odometer-negation-mark");if("."===a)return this.addSpacer(null!=(f=this.format.radix)?f:".",null,"odometer-radix-mark");if(b)for(e=!1;;){if(!this.format.repeating.length){if(e)throw new Error("Bad odometer format without digits");this.resetFormat(),e=!0}if(c=this.format.repeating[this.format.repeating.length-1],this.format.repeating=this.format.repeating.substring(0,this.format.repeating.length-1),"d"===c)break;this.addSpacer(c)}return d=this.renderDigit(),d.querySelector(".odometer-value").innerHTML=a,this.digits.push(d),this.insertDigit(d)},a.prototype.animate=function(a){return p&&"count"!==this.options.animation?this.animateSlide(a):this.animateCount(a)},a.prototype.animateCount=function(a){var c,d,e,f,g,h=this;if(d=+a-this.value)return f=e=u(),c=this.value,(g=function(){var i,j,k;return u()-f>h.options.duration?(h.value=a,h.render(),void z(h.el,"odometerdone")):(i=u()-e,i>b&&(e=u(),k=i/h.options.duration,j=d*k,c+=j,h.render(Math.round(c))),null!=w?w(g):setTimeout(g,b))})()},a.prototype.getDigitCount=function(){var a,b,c,d,e,f;for(d=1<=arguments.length?G.call(arguments,0):[],a=e=0,f=d.length;f>e;a=++e)c=d[a],d[a]=Math.abs(c);return b=Math.max.apply(Math,d),Math.ceil(Math.log(b+1)/Math.log(10))},a.prototype.getFractionalDigitCount=function(){var a,b,c,d,e,f,g;for(e=1<=arguments.length?G.call(arguments,0):[],b=/^\-?\d*\.(\d*?)0*$/,a=f=0,g=e.length;g>f;a=++f)d=e[a],e[a]=d.toString(),c=b.exec(e[a]),e[a]=null==c?0:c[1].length;return Math.max.apply(Math,e)},a.prototype.resetDigits=function(){return this.digits=[],this.ribbons=[],this.inside.innerHTML="",this.resetFormat()},a.prototype.animateSlide=function(a){var b,c,d,f,g,h,i,j,k,l,m,n,o,p,q,s,t,u,v,w,x,y,z,B,C,D,E;if(s=this.value,j=this.getFractionalDigitCount(s,a),j&&(a*=Math.pow(10,j),s*=Math.pow(10,j)),d=a-s){for(this.bindTransitionEnd(),f=this.getDigitCount(s,a),g=[],b=0,m=v=0;f>=0?f>v:v>f;m=f>=0?++v:--v){if(t=A(s/Math.pow(10,f-m-1)),i=A(a/Math.pow(10,f-m-1)),h=i-t,Math.abs(h)>this.MAX_VALUES){for(l=[],n=h/(this.MAX_VALUES+this.MAX_VALUES*b*e),c=t;h>0&&i>c||0>h&&c>i;)l.push(Math.round(c)),c+=n;l[l.length-1]!==i&&l.push(i),b++}else l=function(){E=[];for(var a=t;i>=t?i>=a:a>=i;i>=t?a++:a--)E.push(a);return E}.apply(this);for(m=w=0,y=l.length;y>w;m=++w)k=l[m],l[m]=Math.abs(k%10);g.push(l)}for(this.resetDigits(),D=g.reverse(),m=x=0,z=D.length;z>x;m=++x)for(l=D[m],this.digits[m]||this.addDigit(" ",m>=j),null==(u=this.ribbons)[m]&&(u[m]=this.digits[m].querySelector(".odometer-ribbon-inner")),this.ribbons[m].innerHTML="",0>d&&(l=l.reverse()),o=C=0,B=l.length;B>C;o=++C)k=l[o],q=document.createElement("div"),q.className="odometer-value",q.innerHTML=k,this.ribbons[m].appendChild(q),o===l.length-1&&r(q,"odometer-last-value"),0===o&&r(q,"odometer-first-value");return 0>t&&this.addDigit("-"),p=this.inside.querySelector(".odometer-radix-mark"),null!=p&&p.parent.removeChild(p),j?this.addSpacer(this.format.radix,this.digits[j-1],"odometer-radix-mark"):void 0}},a}(),m.options=null!=(E=window.odometerOptions)?E:{},setTimeout(function(){var a,b,c,d,e;if(window.odometerOptions){d=window.odometerOptions,e=[];for(a in d)b=d[a],e.push(null!=(c=m.options)[a]?(c=m.options)[a]:c[a]=b);return e}},0),m.init=function(){var a,b,c,d,e,f;if(null!=document.querySelectorAll){for(b=document.querySelectorAll(m.options.selector||".odometer"),f=[],c=0,d=b.length;d>c;c++)a=b[c],f.push(a.odometer=new m({el:a,value:null!=(e=a.innerText)?e:a.textContent}));return f}},null!=(null!=(F=document.documentElement)?F.doScroll:void 0)&&null!=document.createEventObject?(D=document.onreadystatechange,document.onreadystatechange=function(){return"complete"===document.readyState&&m.options.auto!==!1&&m.init(),null!=D?D.apply(this,arguments):void 0}):document.addEventListener("DOMContentLoaded",function(){return m.options.auto!==!1?m.init():void 0},!1),"function"==typeof define&&define.amd?define(["jquery"],function(){return m}):typeof exports===!1?module.exports=m:window.Odometer=m}).call(this);
 //odometer end

(function($) {

  function randomNumber(min, max){
     return Math.floor(Math.random() * (1 + max - min) + min);
  }

  //anchor scroll

  $(function() {
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - 50
          }, 1000);
          return false;
        }
      }
    });
  });


  //SOCIAL SHARE
    
    /**
     * jQuery function to prevent default anchor event and take the href * and the title to make a share popup
     *
     * @param  {[object]} e           [Mouse event]
     * @param  {[integer]} intWidth   [Popup width defalut 500]
     * @param  {[integer]} intHeight  [Popup height defalut 400]
     * @param  {[boolean]} blnResize  [Is popup resizeabel default true]
     */
    $.fn.customerPopup = function (e, intWidth, intHeight, blnResize) {
      
      // Prevent default anchor event
      e.preventDefault();
      
      // Set values for window
      intWidth = intWidth || '500';
      intHeight = intHeight || '400';
      strResize = (blnResize ? 'yes' : 'no');

      // Set title and open popup with focus on it
      var strTitle = ((typeof this.attr('title') !== 'undefined') ? this.attr('title') : 'Social Share'),
          strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,            
          objWindow = window.open(this.attr('href'), strTitle, strParam).focus();
    }
    
    /* ================================================== */
    
    $(document).ready(function ($) {
      $('.customer.share').on("click", function(e) {
        $(this).customerPopup(e);
      });
    });
      

  //anime functions
  function radardots() {
    var radardots = new TimelineLite();
    radardots.to($(".radar .line"), 5, {rotation:"+=360",ease: Power0.easeNone }, 0)
    .to($(".radar .ring1"), 0.2, {opacity:"1" }, 0)
    .to($(".radar .ring1"), 1, {opacity:"0" }, 0.5)

    .to($(".radar .ring2"), 0.2, {opacity:"1" }, 1.4)
    .to($(".radar .ring2"), 1, {opacity:"0" }, 1.9)

    .to($(".radar .ring3"), 0.2, {opacity:"1" }, 2)
    .to($(".radar .ring3"), 1, {opacity:"0" }, 2.5)

    .to($(".radar .ring4"), 0.2, {opacity:"1" }, 3)
    .to($(".radar .ring4"), 1, {opacity:"0" }, 3.5)

    .to($(".radar .ring5"), 0.2, {opacity:"1" }, 4)
    .to($(".radar .ring5"), 1, {opacity:"0" }, 4.5)

    .to($(".radar .ring6"), 0.2, {opacity:"1" }, 3.1)
    .to($(".radar .ring6"), 1, {opacity:"0" }, 3.6)
  }
  function coachingring() {
    $(".coachingring .otherline").each(function(){
        var coachingring = new TimelineLite();
            coachingring.staggerTo($(this), 1.5, {rotation: randomNumber(0, 360) },0, 0)
            .staggerTo($(this), 2, {rotation: "0_cw" }, 0, 2.5)
    });
  };
  function assess() {
    $(".assessmentring .helper").prepend("<div class='extra'></div>");
    var wid = $(".assessmentring .helper").outerWidth();

    $(".assessmentring .extra:first-child").each(function(){
      var assess = new TimelineLite();
          assess.to($(this), 0, {left:"-140%"}, 0)
                .to($(this), 0.5, {opacity:"1"}, 0)
                .from($(this), 1, {scaleX:"0", scaleY:"0"}, 0)
                .to($(this), 0.5, {left:"-85%"}, 1)
                .to($(this), 0.5, {left:"0%"}, 2.5)
                .to($(this), 0.5, {width:"30%", height:"30%", borderColor: "#000", ease: Back.easeOut.config(4) }, 3)
                .to($(this).last(), 0.5, {width: "100%", height: "100%", left:"-2px"}, 4)
                .to($(this).last(), 0.3, {opacity:"0"}, 4.3)
    });
    setTimeout(function() { 
      $(".assessmentring .helper .extra").last().remove();
    }, 5000);
  }
  function clock() {
    var clock = new TimelineLite();
    clock.to($(".clock .tim1"), 0.1, {rotation:"+=6"},0)
  }
  //slick carousel
  function slicks() {
    $(".sliders").slick({
      infinite: true,
      arrows:false,
      autoplay: true,
      autoplaySpeed: 5000,
    });
  }
  //counter
  function counter() {
      $(".odometer").each(function(){
        xval = $(this).attr("data-value");  
        $(this).html(xval);
      })
  }


  //SCROLLMAGIC!
  var controller = new ScrollMagic.Controller();

  //Boxes scroll anime

  function boxes() {
    //Boxes

    var windowsize = $(window).width();
    windowsize = $(window).width();
    if (windowsize < 1024) {
        var mix = new TimelineLite();
        mix.from($(".mixer .b1"), 0.4, {opacity: "0", y:"-20"}, 0)
          .from($(".mixer .b2"), 0.4, {opacity: "0", y: "-20"}, 0.4)
          .from($(".mixer .b3"), 0.4, {opacity: "0", y:"-20"}, 0.8)
          .from($(".mixer .b4"), 0.4, {opacity: "0", y: "-20"}, 1.2)
          .from($(".mixer .b5"), 0.4, {opacity: "0", y:"-20"}, 1.6)
          .from($(".mixer .b6"), 0.4, {opacity: "0", y:"-20"}, 2)
          .from($(".mixer .b7"), 0.4, {opacity: "0", y:"-20"}, 2.4)
          .from($(".mixer .b8"), 0.4, {opacity: "0", y:"-20"}, 2.8)
          .from($(".mixer .b9"), 0.4, {opacity: "0", y:"-20"}, 3.2)
          .from($(".mixer .b10"), 0.4, {opacity: "0", y:"-20"}, 3.6)
          .from($(".mixer .b11"), 0.4, {opacity: "0", y:"-20"}, 4)
    }
    else {
        var mix = new TimelineLite();
        mix.from($(".mixer .b1"), 0.4, {opacity: "0", y:"20"}, 0)
          .from($(".mixer .b2"), 0.4, {opacity: "0", x: "-20"}, 0.4)
          .from($(".mixer .b3"), 0.4, {opacity: "0", y:"20"}, 0.8)
          .from($(".mixer .b4"), 0.4, {opacity: "0", x: "-20"}, 1.2)
          .from($(".mixer .b5"), 0.4, {opacity: "0", y:"20"}, 1.6)
          .from($(".mixer .b6"), 0.4, {opacity: "0", x:"-20"}, 2)
          .from($(".mixer .b7"), 0.4, {opacity: "0", y:"20"}, 2.4)
          .from($(".mixer .b8"), 0.4, {opacity: "0", x:"-20"}, 2.8)
          .from($(".mixer .b9"), 0.4, {opacity: "0", y:"20"}, 3.2)
          .from($(".mixer .b10"), 0.4, {opacity: "0", x:"-20"}, 3.6)
          .from($(".mixer .b11"), 0.4, {opacity: "0", y:"20"}, 4)
    }

    

    var scene = new ScrollMagic.Scene({
      triggerElement: ".mixer",
      reverse:false
    })
    .setTween(mix) // trigger a TweenMax.to tween
    .addTo(controller);
  }

  function border() {
    var mix = new TimelineLite();
    mix.from($(".border"), 0.4, {width: "0"}, 0)
    var scene = new ScrollMagic.Scene({
      triggerElement: ".border",
      reverse:false,
      offset: -200,
    })
    .setTween(mix) // trigger a TweenMax.to tween
    .addTo(controller);
  }

  function radarring() {
    var rar = new TimelineLite();
    rar.from($(".radar"), 0.8, {opacity: "0"}, 0)
        .from($(".radar"), 0.8, {scale: "0.5", ease: Back.easeOut.config(4)}, 0)
        .from($(".radar .line"), 0.6, {height: "0"}, 0.8)
        .from($(".radarb h2"), 0.4, {y:"20", opacity: "0"}, 0.1)
        .from($(".radarb p"), 0.4, {y:"20", opacity: "0"}, 0.15)
        .from($(".radarb a"), 0.4, {y:"20", opacity: "0"}, 0.2)


    var scene = new ScrollMagic.Scene({
      triggerElement: ".items",
      reverse:false,
      offset: -200,
    })
    .on('start', function () {
      setTimeout(function(){
        radardots();
        window.setInterval(function(){
          coachingring();
          radardots();
        }, 5000);
      }, 1600)
    })
    .setTween(rar) // trigger a TweenMax.to tween
    .addTo(controller);
  }

  function coachring() {
    console.log("coach")
    var coach = new TimelineLite();
    coach.from($(".coaching .coachingring"), 0.4, {opacity: "0", scale: "0.8"}, 0)
    .to($(".coaching"), 0.4, {className:"+=bor"}, 0)
    .from($(".coaching .line, .coaching .otherline"), 0.8, {height: "0"}, 0.8)
    .from($(".coaching h2"), 0.4, {y:"20", opacity: "0"}, 0.1)
    .from($(".coaching p"), 0.4, {y:"20", opacity: "0"}, 0.15)
    .from($(".coaching a"), 0.4, {y:"20", opacity: "0"}, 0.2)

    var scene = new ScrollMagic.Scene({
      triggerElement: ".items",
      offset: -200,
      reverse:false
    })
    .on('start', function () {
      setTimeout(function(){
        coachingring();
        window.setInterval(function(){
          coachingring();
        }, 5000);
      }, 1600)
    })
    .setTween(coach) // trigger a TweenMax.to tween
    .addTo(controller);
  }

  function assessring() {
    var assessx = new TimelineLite();
    assessx.from($(".assessment .assessmentring"), 0.4, {opacity: "0", scale: "0.8"}, 0)
    .from($(".assessment h2"), 0.4, {y:"20", opacity: "0"}, 0.1)
    .from($(".assessment p"), 0.4, {y:"20", opacity: "0"}, 0.15)
    .from($(".assessment a"), 0.4, {y:"20", opacity: "0"}, 0.2)

    var scene = new ScrollMagic.Scene({
      triggerElement: ".items",
      reverse:false
    })
    .on('start', function () {
      setTimeout(function(){
        assess();
        window.setInterval(function(){
          assess()
        }, 1666);
      }, 1600)
    })
    .setTween(assessx) // trigger a TweenMax.to tween
    .addTo(controller);
  }

  function contactus() {
    //contactus 
    var tl6 = new TimelineLite();
    tl6.from($(".contactus"), 0.4, {opacity: "0", y:"20"}, 0)

    var scene = new ScrollMagic.Scene({
      triggerElement: ".contactus",
      reverse:false,
      offset: -200,
    })
    .setTween(tl6)
    .addTo(controller);
  }

  function clockscroll() {
    var cl = new TimelineLite();
    cl.from($(".time .clock"), 0.8, {opacity: "0", scale: "0.8"}, 0)
      .from($(".time .clock .tim1, .time .clock .tim2"), 0.8, {height: "0"}, 0.8)
      .from($(".time h2"), 0.4, {opacity: "0", x:"20"}, 0)
      .from($(".time p"), 0.4, {opacity: "0", x:"20"}, 0.2)
      .from($(".time a"), 0.4, {opacity: "0", x:"20"}, 0.4)

    var scene = new ScrollMagic.Scene({
      triggerElement: ".time",
      reverse:false
    })
    .on('start', function () {
      setTimeout(function(){
        clock()
        window.setInterval(function(){
          clock();
        }, 1000);
      }, 1600)
    })
    .setTween(cl)
    .addTo(controller);
  }

  function blogbox() {
    var tl5 = new TimelineLite();
    tl5.from($(".blogbox .title"), 0.4, {opacity: "0", y:"20"}, 0)
        .from($(".blogbox .midbutton"), 0.4, {opacity: "0", y:"20"}, 0)
        .from($(".blogbox .post"), 0.4, {opacity: "0", y:"20"}, 0.2)

        //blogbox
        var scene = new ScrollMagic.Scene({
          triggerElement: ".blogbox",
          reverse:false,
          offset: -200,
        })
        .setTween(tl5) // trigger a TweenMax.to tween
        .addTo(controller);
  }

  function bluebox() {
      var blu = new TimelineLite();
      blu.from($(".randomfact"), 0.4, {opacity: "0", y:"20"}, 0)

      //blogbox
      var scene = new ScrollMagic.Scene({
        triggerElement: ".randomfact",
        offset: -300,
        reverse:false
      })
      .setTween(blu) // trigger a TweenMax.to tween
      .addTo(controller);
  }


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages  

        //menubutton
        function burger(){

          var t = new TimelineLite();
            t.to($(".menubox"), 0.5, {opacity:"1",  display:"block"})
            .staggerFrom($(".menubox li"), 0.5, {opacity:"0", x:"-20"}, 0.05, 0.2)
            .from($(".menubox .logo"), 0.5, {opacity:"0", x:"-20"}, 0.1)
            // set the reversed property to true
            t.reversed(true);
            // toggle function
            $(".menubutton, .menuback").click(function(){
              $(".menubutton, .menuback").toggleClass("active");
              $(".menubox").toggleClass("active");
              t.reversed() ? t.play() : t.reverse();
            });
        }
        function reverse() {
          t.reversed() ? t.play() : t.reverse();
        }
        burger();

        //sharebutton
        function share(){
          var tx = new TimelineLite();
            tx.staggerTo($(".share .blist a"), 0.5, {opacity:"1"}, 0.2, 0)
              .staggerFrom($(".share .blist a"), 0.5, {x:"10"}, 0.2, 0)
            tx.reversed(true);
            // toggle function
            $(".meta .share .button").click(function(e){
              e.preventDefault();
              tx.reversed() ? tx.play() : tx.reverse();
            });
            $(".share .blist a").click(function(){
              tx.reversed() ? tx.play() : tx.reverse();
            });
        }
        function reverse() {
          tx.reversed() ? t.play() : t.reverse();
        }
        share();

        //Pageload functions
        $(document).ready(function(){
          $(window).on("load", function(){
              window.requestAnimationFrame(function() {
                function fronts(){
                  var t = new TimelineLite();
                }
                fronts();
              });
          });  
        });


        $(document).foundation(); // Foundation JavaScript
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        //Frontpage gsap
        $(document).ready(function(){
          $(window).on("load", function(){
              window.requestAnimationFrame(function() {
                function frontfronts(){
                  var tx = new TimelineLite();
                  tx.to($("span.one"), 0.5, {opacity:"1"}, 0)
                    .to($(".menubutton"), 0.5, {opacity:"1"}, 0)
                    .staggerTo($(".menubutton span"), 0.3, {width:"45"},0.3, 0)
                    .to($(".floor"), 0.5, {opacity:"1", x:"0"}, 1)
                    .from($(".floor"), 0.5, {x:"10"}, 1)
                    .to($(".imagebox"), 0.5, {opacity:"1"}, 1.5)
                    .to($(".imagebox"), 3, {rotation: "-5"}, 1.8)
                    .staggerTo($(".introtext p"), 0.5, {opacity:"1"}, 0.3, 1.5)
                    .staggerFrom($(".introtext p"), 0.5, {x: "-10"}, 0.3, 1.5)
                }
                frontfronts();
              });
          });  
        });

        slicks();

        //first ring
        var tl = new TimelineLite();
        tl.from($(".executive .radar"), 0.8, {opacity: "0"}, 0)
          .from($(".executive .radar"), 0.8, {scale: "0.8", ease: Back.easeOut.config(4)}, 0)
          .from($(".executive .radar .line"), 0.6, {height: "0"}, 0.8)
          .from($(".executive h2"), 0.4, {x: "20", opacity: "0"}, 0)
          .from($(".executive p"), 0.4, {x: "20", opacity: "0"}, 0.05)
          .from($(".executive a"), 0.4, {x: "20", opacity: "0"}, 0.1)
          .to($(".executive"), 0, {className:"+=bor"},0.15)

        //second rings
        var tl2 = new TimelineLite();
        tl2.from($("#trigger2 .coachingring, #trigger2 .assessmentring"), 0.4, {opacity: "0", scale: "0.8"}, 0)
        .to($("#trigger2 .coaching"), 0.4, {className:"+=bor"}, 0)
        .from($("#trigger2 .coaching .line,#trigger2 .coaching .otherline"), 0.8, {height: "0"}, 0.8)
        .from($("#trigger2 h2"), 0.4, {y:"20", opacity: "0"}, 0.1)
        .from($("#trigger2 p"), 0.4, {y:"20", opacity: "0"}, 0.15)
        .from($("#trigger2 a"), 0.4, {y:"20", opacity: "0"}, 0.2)

        //Image
        var tl3 = new TimelineLite();
        tl3.from($(".mainbanner"), 0.4, {opacity: "0", y:"20"}, 0)

        //Counter rings
        var tl4 = new TimelineLite();
        tl4.from($(".counters h2.mains"), 0.4, {opacity: "0", y:"20"}, 0)
          .from($(".counters .box span"), 0.4, {opacity: "0", y:"20"}, 0.4)
          .from($(".counters h2.color"), 0.4, {opacity: "0", y:"20"}, 0.6)
          .from($(".counters .person .port"), 0.4, {opacity: "0", y:"20"}, 0.6)
          .staggerFrom($(".counters .person .inf span"), 0.4, {opacity: "0", x:"20"}, 0.2, 0.6)
          .to($(".leftpromo"), 0, {className:"+=bor"},0.4)

        var scene = new ScrollMagic.Scene({
          triggerElement: ".counters",
          reverse:false,
        })
        .on('start', function () {
           counter();
        })
        .setTween(tl4)
        .addTo(controller);

        // build scene
        var scene = new ScrollMagic.Scene({
          triggerElement: "#trigger1",
          reverse:false,
          offset: -200,
        })
        .on('start', function () {
          setTimeout(function(){
            radardots();
            window.setInterval(function(){
              radardots();
            }, 5000);
          }, 1666);
        })
        .setTween(tl) // trigger a TweenMax.to tween
        .addTo(controller);

        //bottomrings
        var scene = new ScrollMagic.Scene({
          triggerElement: "#trigger2",
          reverse:false,
          offset: -200,
        })
        .on('start', function () {
           setTimeout(function(){
              coachingring();
              assess();
              window.setInterval(function(){
                coachingring();
              }, 5000);
              window.setInterval(function(){
                assess();
              }, 1666);
          }, 1600)
        })
        .setTween(tl2) // trigger a TweenMax.to tween
        .addTo(controller);

        //Banner
        var scene = new ScrollMagic.Scene({
          triggerElement: ".mainbanner",
          reverse:false,
          offset: -200,
        })
        .setTween(tl3) // trigger a TweenMax.to tween
        .addTo(controller);

        

        //Blogbox slide anime

        blogbox();

        //Contactus slide anime
        contactus()



      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_template_executive': {
      init: function() {
        function radardots2() {
          var radardots = new TimelineLite();
          radardots.to($(".radar .line"), 5, {rotation:"+=360",ease: Power0.easeNone }, 0)
          .to($(".radar div.ring1"), 0.3, {opacity:"1" }, 0)
          .to($(".radar div.ring1"), 1, {opacity:"0" }, 0.5)

          .to($(".radar div.ring2"), 0.3, {opacity:"1" }, 1.4)
          .to($(".radar div.ring2"), 1, {opacity:"0" }, 1.9)

          .to($(".radar div.ring3"), 0.3, {opacity:"1" }, 2)
          .to($(".radar div.ring3"), 1, {opacity:"0" }, 2.5)

          .to($(".radar div.ring4"), 0.3, {opacity:"1" }, 3.2)
          .to($(".radar div.ring4"), 1, {opacity:"0" }, 3.7)

          .to($(".radar div.ring5"), 0.3, {opacity:"1" }, 4.2)
          .to($(".radar div.ring5"), 1, {opacity:"0" }, 4.7)

          .to($(".radar div.ring6"), 0.3, {opacity:"1" }, 3.5)
          .to($(".radar div.ring6"), 1, {opacity:"0" }, 4)
        }

        var tl = new TimelineLite();
        tl.to($(".radar"), 0.8, {opacity: "1"}, 0)
          .from($(".radar"), 0.8, {scale: "0.5"}, 0)
          .from($(".radar .line"), 0.6, {height: "0"}, 0.8)

        setTimeout(function(){
          radardots2();
          window.setInterval(function(){
            radardots2();
          }, 5000);
        },1400)


        //SCROLLS
        boxes();
        coachring();
        assessring();
        clockscroll();
        contactus();
        blogbox();
        bluebox();


      }
    },
    'page_template_template_coaching': {
       init: function() {

        var tl = new TimelineLite();
        tl.to($(".coachingring"), 0.8, {opacity: "1"}, 0)
          .from($(".coachingring"), 0.8, {scale: "0.5"}, 0)
          .from($(".coachingring .line, .coachingring .otherline"), 0.6, {height: "0"}, 0.8)

        setTimeout(function(){
          coachingring();
          window.setInterval(function(){
            coachingring();
          }, 5000);
        },1400);

        boxes();
        clockscroll();
        bluebox();
        blogbox();
        assessring();
        radarring();
        contactus();
       }
    },
    'page_template_template_assessment': {
       init: function() {

        var tl = new TimelineLite();
        tl.to($(".assessmentring"), 0.8, {opacity: "1"}, 0)
          .from($(".assessmentring"), 0.8, {scale: "0.5"}, 0)

        setTimeout(function(){
           assess()
           window.setInterval(function(){
             assess()
           }, 1666);
        },833);

       


        boxes();
        clockscroll();
        bluebox();
        blogbox();
        radarring();
        coachring();
       }
    },
    'page_template_template_about': {
       init: function() {
        $(document).ready(function(){
          $(window).on("load", function(){
              window.requestAnimationFrame(function() {
                function frontfronts(){
                  var tx = new TimelineLite();
                  tx.to($(".imagebox"), 0.5, {opacity:"1"}, 0)
                    .to($(".imagebox"), 3, {rotation: "7"}, 0.3)
                    .staggerTo($(".introtext p"), 0.5, {opacity:"1"}, 0.3, 0)
                    .staggerFrom($(".introtext p"), 0.5, {x: "-10"}, 0.3, 0)
                }
                frontfronts();
                slicks();
              });
          });  
        });

        $(".read").click(function(){
          $(this).toggleClass("active");
          $(this).prev().toggleClass("active");
        })

        //Counter rings
        var tl4 = new TimelineLite();
        tl4.from($(".counters h2.mains"), 0.4, {opacity: "0", y:"20"}, 0)
          .from($(".counters .box span"), 0.4, {opacity: "0", y:"20"}, 0.4)
          .from($(".counters h2.color"), 0.4, {opacity: "0", y:"20"}, 0.6)
          .from($(".counters .person .port"), 0.4, {opacity: "0", y:"20"}, 0.6)
          .staggerFrom($(".counters .person .inf span"), 0.4, {opacity: "0", x:"20"}, 0.2, 0.6)
          .to($(".leftpromo"), 0, {className:"+=bor"},0.4)

        var scene = new ScrollMagic.Scene({
          triggerElement: ".counters",
          reverse:false,
        })
        .on('start', function () {
           counter();
        })
        .setTween(tl4)
        .addTo(controller);

       }
    },
    'page_template_template_contact': {
      init: function() {

        //google map start
        $(".read").click(function(){
          $(this).toggleClass("active");
          $(this).prev().toggleClass("active");
        })

        function new_map( $el ) {
          var $markers = $el.find('.marker');
          var args = {
            zoom    : 16,
            center    : new google.maps.LatLng(0, 0),
            mapTypeId : google.maps.MapTypeId.ROADMAP
          };
          var map = new google.maps.Map( $el[0], args);
          // add a markers reference
          map.markers = [];
          // add markers
          $markers.each(function(){
              add_marker( $(this), map );
          });
          // center map
          center_map( map );
          // return
          return map; 
        }

        function add_marker( $marker, map ) {

          // var
          var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

          // create marker
          var image = templateDir + '/dist/images/asukoht.png';
          var marker = new google.maps.Marker({
            position  : latlng,
            icon: {
              url: image,
              size: new google.maps.Size(130, 130),
              scaledSize: new google.maps.Size(130, 130)
            },
            map     : map 
            
          });

          map.set('styles', [
              {
                  "featureType": "administrative",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "color": "#444444"
                      }
                  ]
              },
              {
                  "featureType": "landscape",
                  "elementType": "all",
                  "stylers": [
                      {
                          "color": "#f2f2f2"
                      }
                  ]
              },
              {
                  "featureType": "poi",
                  "elementType": "all",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "all",
                  "stylers": [
                      {
                          "saturation": -100
                      },
                      {
                          "lightness": 45
                      }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "all",
                  "stylers": [
                      {
                          "visibility": "simplified"
                      }
                  ]
              },
              {
                  "featureType": "road.arterial",
                  "elementType": "labels.icon",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "transit",
                  "elementType": "all",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "water",
                  "elementType": "all",
                  "stylers": [
                      {
                          "color": "#a7a7a7"
                      },
                      {
                          "visibility": "on"
                      }
                  ]
              }
          ]);

          // add to array
          map.markers.push( marker );

          // if marker contains HTML, add it to an infoWindow
          if( $marker.html() )
          {
            // create info window
            var infowindow = new google.maps.InfoWindow({
              content   : $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {

              infowindow.open( map, marker );

            });
          }

        }

        function center_map( map ) {
          // vars
          var bounds = new google.maps.LatLngBounds();

          // loop through all markers and create bounds
          $.each( map.markers, function( i, marker ){

            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

            bounds.extend( latlng );

          });

          // only 1 marker?
          if( map.markers.length == 1 )
          {
            // set center of map
              map.setCenter( bounds.getCenter() );
              map.setZoom( 16 );
          }
          else
          {
            // fit to bounds
            map.fitBounds( bounds );
          }
        }
        var map = null;
        $(document).ready(function(){
          $('.acf-map').each(function(){
            map = new_map( $(this) );
          });
        });
        //google map end
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
